import { apiCall } from "./Interceptor";

const VOLTAGE_LEVEL_ALL = "/voltageLevel/getAll/public";

const getAllVoltageLevel = async () => {
    const response = await apiCall.get(VOLTAGE_LEVEL_ALL);
    return response;
}

export default {
    getAllVoltageLevel,
};
